import { render, staticRenderFns } from "./ProgramDetailItem.vue?vue&type=template&id=2bf5ede5&scoped=true&"
import script from "./ProgramDetailItem.vue?vue&type=script&lang=js&"
export * from "./ProgramDetailItem.vue?vue&type=script&lang=js&"
import style0 from "./ProgramDetailItem.vue?vue&type=style&index=0&id=2bf5ede5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf5ede5",
  null
  
)

export default component.exports